export default {
	name: {
		value: "name",
		display: true,
		label: "Name",
        component: "v-text-field",
	},
};
